<template>
  <span class="svg-icon-audio">
    <svg :style="`width:${width}px;height:${width}px;fill:none;`" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
      <path d="M20.4057 18.5937L15.6218 13.8098" :stroke="color" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
      <path d="M15.6218 13.8097L12.2006 17.2309C11.4468 17.9847 10.2194 17.9847 9.46558 17.2309L5.36786 13.1331C4.61403 12.3793 4.61403 11.152 5.36786 10.3981L12.2006 3.56537C12.9544 2.81154 14.1818 2.81154 14.9357 3.56537L19.0334 7.66311C19.7872 8.41693 19.7872 9.6443 19.0334 10.3981L15.6218 13.8097Z" :stroke="color" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
      <path d="M3 21H8.79866" :stroke="color" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
      <path d="M7.40698 8.35889L14.2397 15.1916" :stroke="color" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
  </span>
</template>

<script>
export default {
  props: {
    width: { type: Number, default: 24 },
    color: { type: String, default () { return this.$store.state.color['coolGrey-500'] } },
    color2: { type: String, default: '#E0E3E6' },
    isTwoTone: { type: Boolean }
  }
}
</script>